<template>
	<MarketSoundingDecisionConfirmModal
		title-single-key="marketSoundingDecision.setInterested.confirm.title"
		title-multi-key="marketSoundingDecision.setInterested.selected.confirm.title"
		msg-single-key="marketSoundingDecision.setInterested.confirm.msg"
		msg-multi-key="marketSoundingDecision.setInterested.selected.confirm.msg"
		:evaluation-status="enumDef.InvestorSellerDebtorConfigStatus.Approved"
		evaluation-msg-key="marketSoundingDecision.companyEvaluation.setInterested.msg"
		evaluation-matching-decision-msg-single-key="marketSoundingDecision.companyEvaluation.setInterested.alreadyMatchingDecision.single.msg"
		evaluation-matching-decision-msg-multiple-key="marketSoundingDecision.companyEvaluation.setInterested.alreadyMatchingDecision.multiple.msg"
		evaluation-not-matching-decision-msg-single-key="marketSoundingDecision.companyEvaluation.setNotInterested.alreadyMatchingDecision.single.msg"
		evaluation-not-matching-decision-msg-multiple-key="marketSoundingDecision.companyEvaluation.setNotInterested.alreadyMatchingDecision.multiple.msg"
		evaluation-preference-key="approveCompaniesOnDecision"
		evaluate-label-key="marketSoundingDecision.companyEvaluation.choice.approve"
		evaluate-not-label-key="marketSoundingDecision.companyEvaluation.choice.doNotApprove"
		:include-reason="false"
		:max-company-list-height="300"
		@confirm="onConfirm"
		ref="base"
	/>
</template>
<script>
import MarketSoundingDecisionConfirmModalBase from "src/components/templates/investor/riskAssessment/marketSounding/MarketSoundingDecisionConfirmModalBase.vue";
import {enumDef} from "@/common/enumDefs";

export default {
	components: { MarketSoundingDecisionConfirmModal: MarketSoundingDecisionConfirmModalBase },
	data() {
		return {
			enumDef: enumDef
		};
	},
	methods: {
		// Delegate methods
		showWithSingleRow(data) {
			this.$refs.base.showWithSingleRow(data);
		},
		showWithMultipleRows(rows) {
			this.$refs.base.showWithMultipleRows(rows);
		},
		onConfirm(...args) {
			// Forward event with original signature
			this.$emit('confirm', ...args);
		},
	},
};
</script>
